import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import PaginatedResponse from '@/types/paginatedResponse';
import { RequestedDocument } from '@/types/requestedDocument';
import ajax from '@/utils/ajax';

const basePath = '/api/dugout/requested_documents';

const RequestedDocumentRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async listByIdPaginated({ id }: { id: string }) {
      const response = await ajax.get({
        url: `${host}${basePath}/${id}/`
      });

      return {
        data: response.data as PaginatedResponse<RequestedDocument[]>,
        isError: false
      };
    }
  };
};

export default RequestedDocumentRepository;
